import { update } from 'lodash';
import { ModelState } from '@/store/modules/cms/types';

const appInfoModel: ModelState = {
  name: 'appInfo',
  title: '应用配置',
  type: 'single',
  tplName: 'single',
  listOperations: [],
  api: {
    detail: '/admin/cms/appInfo/detail',
    update: '/admin/cms/appInfo/save',
  },
  formFields: [
    {
      field: 'productTopImage',
      title: '产品页顶图',
      formType: 'image',
      isForm: true,
      required: true,
    },
    {
      field: 'customerServicePhone',
      title: '客服电话',
      formType: 'input',
      isForm: true,
      required: true,
    },
    {
      field: 'customerServiceContactName',
      title: '客服联系人名称',
      formType: 'input',
      isForm: true,
      required: true,
    },
    {
      field: 'labServicePhone',
      title: '实验负责人电话',
      formType: 'input',
      isForm: true,
      required: true,
    },
    {
      field: 'labServiceContactName',
      title: '实验负责人名称',
      formType: 'input',
      isForm: true,
      required: true,
    },
    {
      field: 'extComponyPhone',
      title: '实验收件人电话',
      formType: 'input',
      isForm: true,
      required: true,
    },
    {
      field: 'extComponyContactName',
      title: '实验收件人姓名',
      formType: 'input',
      isForm: true,
      required: true,
    },
    {
      field: 'extComponyAddress',
      title: '实验收件人地址',
      formType: 'textarea',
      isForm: true,
      required: true,
    },
  ],
  searchFields: [],
  listFields: [],
};
const videoModel: ModelState = {
  name: 'video',
  title: '视频管理',
  type: 'list',
  tplName: 'list',
  listOperations: ['edit', 'delete'],
  pageOperations: ['create'],
  // API 接口
  api: {
    list: '/admin/cms/video/list',
    // create: '/admin/cms/video/save',
    update: '/admin/cms/video/save',
    delete: '/admin/cms/video/del',
    detail: '/admin/cms/video/detail',
    updateStatus: '/admin/cms/video/updatestatus',
  },
  // 表单字段-所有字段
  // 来自字典的字段：类型
  // 来自其他模型的字段：分类id
  // 普通字段：手机号
  formFields: [
    {
      field: 'title',
      title: '名称',
      formType: 'input',
      isForm: true,
      required: true,
      rules: [
        {required: true, message: '请输入名称!', trigger: 'blur'},
        {minLength: 1, maxLength: 20, message: '名称长度必须在1-20个字符之间', trigger: 'blur'}
      ],
    },
    {
      field: 'type',
      title: '分类',
      formType: 'dict',
      dictGroupId: 1,
      isForm: true,
      required: true,
      options: [{ label: '常见问题', value: 'faq' },{ label: '实验视频', value: 'experiment' },{ label: '复杂制剂中心', value: 'topExp' },
    ]},
    {
      field: 'fileUrl',
      title: '视频',
      formType: 'file',
      dictGroupId: 1,
      isForm: true,
      required: true,
      accept: 'video/mp4, video/webm, video/avi, video/mov, video/mkv',
      limit: 1,
      rules: [
        {required: true, message: '请上传视频!', trigger: 'change'},
      ],
    },
    {
      field: 'cover',
      title: '封面',
      formType: 'image',
      isForm: true,
      limit: 1,
    }
  ],
  // 搜索字段
  searchFields: [
    { title: '名称', field: 'title', searchType: 'input', searchWay: '=' },
    { title: '分类', field: 'type', searchType: 'dict', searchWay: '=' },
    { title: '状态', field: 'status', searchType: 'status', searchWay: '=' },
  ],
  // 列表字段
  listFields: [
    { title: '#', field: '#', showUI: '_index' },
    { title: '名称', field: 'title', showUI: '' },  
    { title: '分类', field: 'type', showUI: 'dict' },
    { title: '视频地址', field: 'fileUrl', showUI: 'url' },
    { title: '状态', field: 'status', showUI: 'status' },
    { title: '创建时间', field: 'createTime', showUI: 'dateTime' },
    { title: '更新时间', field: 'updateTime', showUI: 'dateTime' },
  ],
};
const bannerModel: ModelState = {
  name: 'bannerList',
  title: 'banner管理',
  type: 'list',
  tplName: 'list',
  listOperations: ['edit', 'delete'],
  pageOperations: ['create'],
  // API 接口
  api: {
    list: '/admin/cms/bannerList/list',
    // create: '/admin/cms/bannerList/save',
    update: '/admin/cms/bannerList/save',
    delete: '/admin/cms/bannerList/del',
    detail: '/admin/cms/bannerList/detail',
    updateStatus: '/admin/cms/bannerList/updatestatus',
  },
  // 表单字段-所有字段
  // 来自字典的字段：类型
  // 来自其他模型的字段：分类id
  // 普通字段：手机号
  formFields: [
    {
      field: 'title',
      title: '名称',
      formType: 'input',
      isForm: true,
      required: true,
      rules: [
        {required: true, message: '请输入名称!', trigger: 'blur'},
        {minLength: 1, maxLength: 20, message: '名称长度必须在1-20个字符之间', trigger: 'blur'}
      ],
    },
    {
      field: 'imageUrl',
      title: 'banner',
      formType: 'image',
      isForm: true,
      limit: 1,
    }
  ],
  // 搜索字段
  searchFields: [],
  // 列表字段
  listFields: [
    { title: '#', field: '#', showUI: '_index' },
    { title: '名称', field: 'title', showUI: '' },  
    { title: 'banner', field: 'imageUrl', showUI: 'image' },  
    { title: '状态', field: 'status', showUI: 'status' },
    { title: '创建时间', field: 'createTime', showUI: 'dateTime' },
    { title: '更新时间', field: 'updateTime', showUI: 'dateTime' },
  ],
};

const productModel: ModelState = {
  name: 'product',
  title: '产品管理',
  type: 'list',
  tplName: 'list',
  listOperations: ['edit', 'delete'],
  pageOperations: ['create'],
  // API 接口
  api: {
    list: '/admin/cms/product/list',
    // create: '/admin/cms/product/save',
    update: '/admin/cms/product/save',
    delete: '/admin/cms/product/del',
    detail: '/admin/cms/product/detail',
    updateStatus: '/admin/cms/product/updatestatus',
  },
  // 表单字段-所有字段
  // 来自字典的字段：类型
  // 来自其他模型的字段：分类id
  // 普通字段：手机号
  formFields: [
    {
      field: 'title',
      title: '名称',
      formType: 'input',
      isForm: true,
      required: true,
    },
    {
      field: 'cateId',
      title: '分类',
      formType: 'relationOne',
      relationModelName: 'productCate',
      isForm: true,
      required: true,
    },
    {
      field: 'remark',
      title: '备注',
      formType: 'textarea',
      isForm: true,
      required: true,
    },
    {
      field: 'covers',
      title: '封面',
      formType: 'images',
      isForm: true,
      required: true,
      help: '说明:图片最佳尺寸为500像素*500像素，格式jpg、png，大小不超过2M;最多支持上传5张，默认第一张为封面',
      limit: 5,
      accept: 'image/png, image/jpeg, image/webp',
    },
    {
      field: 'content',
      title: '内容',
      formType: 'richText',
      isForm: true,
      required: true,
    },
  ],
  // 搜索字段
  searchFields: [
    { title: '名称', field: 'title', searchType: 'input', searchWay: '=' },
    {
      title: '分类',
      field: 'cateId',
      searchType: 'relationOne',
      searchWay: '=',
    },
    { title: '状态', field: 'status', searchType: 'status', searchWay: '=' },
  ],
  // 列表字段
  listFields: [
    { title: '#', field: '#', showUI: '_index' },
    { title: '名称', field: 'title', showUI: '' },
    { title: '分类', field: 'cateTitle', showUI: '' },
    { title: '主图', field: 'covers', showUI: 'images' },
    { title: '状态', field: 'status', showUI: 'status' },
    { title: '创建时间', field: 'createTime', showUI: 'dateTime' },
    { title: '最后更新时间', field: 'updateTime', showUI: 'dateTime' },
  ],
};
const productCateModel: ModelState = {
  name: 'productCate',
  title: '产品分类',
  type: 'list',
  // 列表 树tree single
  tplName: 'list',

  maxLevel: 0, // 树的最大层级

  // 列表操作
  listOperations: ['edit', 'delete'],
  pageOperations: ['create'],
  // API 接口
  api: {
    list: '/admin/cms/productCate/list',
    // create: '/admin/cms/productCate/save',
    update: '/admin/cms/productCate/save',
    delete: '/admin/cms/productCate/del',
    detail: '/admin/cms/productCate/detail',
    updateStatus: '/admin/cms/productCate/updatestatus',
    download: '/admin/cms/productCate/download',
  },
  // 表单字段-所有字段
  // 来自字典的字段：类型
  // 来自其他模型的字段：分类id
  // 普通字段：手机号
  formFields: [
    {
      field: 'title',
      title: '名称',
      formType: 'input',
      isForm: true,
      required: true,
      rules: [
        {required: true, message: '请输入名称!', trigger: 'blur'},
        {minLength: 1, maxLength: 20, message: '名称长度必须在1-20个字符之间', trigger: 'blur'}
      ],
    },
  ],
  // 搜索字段
  searchFields: [
    { title: '名称', field: 'title', searchType: 'input', searchWay: '=' },
    { title: '状态', field: 'status', searchType: 'status', searchWay: '=' },
  ],
  // 列表字段
  listFields: [
    { title: '#', field: '#', showUI: '_index' },
    { title: '名称', field: 'title', showUI: '' },
    { title: '状态', field: 'status', showUI: 'status' },
    { title: '创建时间', field: 'createTime', showUI: 'dateTime' },
    { title: '更新时间', field: 'updateTime', showUI: 'dateTime' },
  ],
};

const accountModel: ModelState = {
  name: 'account',
  title: '账号管理',
  type: 'list',
  // 列表 树tree single
  tplName: 'list',
  maxLevel: 0, // 树的最大层级
  // 列表操作
  listOperations: ['edit', 'resetPassword'],
  pageOperations: ['create'],
  // API 接口
  api: {
    list: '/admin/account/list',
    // create: '/admin/account/create',
    update: '/admin/account/save',
    delete: '/admin/account/del',
    detail: '/admin/account/detail',
    updateStatus: '/admin/account/updatestatus',
  },

  formFields: [
    {
      field: 'phone',
      title: '手机号',
      formType: 'input',
      isForm: true,
      required: true,
      rules: [
        {required: true, message: '请输入手机号!', trigger: 'blur'},
        {match:/^1[3-9]\d{9}$/,message: '请输入正确的手机号格式',trigger: 'blur'}
      ],
    },
    {
      field: 'nickname',
      title: '姓名',
      formType: 'input',
      isForm: true,
      required: true,
      rules: [
        {required: true, message: '请输入姓名!', trigger: 'blur'},
        {minLength: 2, maxLength: 20, message: '姓名长度必须在2-20个字符之间', trigger: 'blur'}
      ],
    },
    {
      field: 'type',
      title: '类型',
      formType: 'radio',
      isForm: true,
      required: true,
      options: [
        { label: '员工', value: 'staff' },
        { label: '用户', value: 'customer' },
      ],
      rules: [
        {required: true, message: '请选择类型', trigger: 'blur'}
      ],
    },
    {
      field: 'password',
      title: '初始密码',
      formType: 'input',
      isForm: true,
      required: true,
      onlyCreate: true,
    },
    {
      field: 'roles',
      title: '角色',
      formType: 'selectMuilt',
      options: [
        { label: '超级管理员', value: 'admin' },
        { label: '售前管理员', value: 'pre_sales_admin' },
        { label: '售后', value: 'after_sales' },
        { label: '售后管理员', value: 'after_sales_admin' },
        { label: '采购', value: 'purchasin' },
      ],
      required: false,
      isForm: true,
    },
  ],
  // 搜索字段
  searchFields: [
    { title: '姓名', field: 'nickname', searchType: 'input', searchWay: 'like' },
    { title: '手机号', field: 'phone', searchType: 'input', searchWay: 'like' },
    {
      title: '类型',
      field: 'type',
      searchType: 'select',
      searchWay: '=',
      options: [
        { label: '员工', value: 'staff' },
        { label: '用户', value: 'customer' },
      ],
    },
  ],
  // 列表字段
  listFields: [
    { title: '#', field: '#', showUI: '_index' },
    { title: '姓名', field: 'nickname', showUI: '' },
    { title: '手机号', field: 'phone', showUI: '' },
    { title: '类型', field: 'type', showUI: 'dict' },
    { title: '角色', field: 'roles', showUI: 'dict' },
    { title: '状态', field: 'status', showUI: 'status' },
    { title: '创建时间', field: 'createTime', showUI: 'dateTime' },
    { title: '更新时间', field: 'updateTime', showUI: 'dateTime' },
  ],
};
const userModel: ModelState = {
  name: 'user',
  title: '用户管理',
  type: 'list',
  // 列表 树tree single
  tplName: 'list',

  maxLevel: 0, // 树的最大层级

  // 列表操作
  listOperations: [],
  pageOperations: [],
  // API 接口
  api: {
    list: '/admin/user/list',
    // create: '/admin/user/create',
    update: '/admin/user/update',
    delete: '/admin/user/del',
    detail: '/admin/user/detail',
    updateStatus: '/admin/user/updatestatus',
  },
  // 表单字段-所有字段
  // 来自字典的字段：类型
  // 来自其他模型的字段：分类id
  // 普通字段：手机号
  formFields: [
    {
      field: 'phone',
      title: '手机号',
      formType: 'input',
      isForm: true,
      required: true,
    },
    {
      field: 'nickname',
      title: '姓名',
      formType: 'input',
      isForm: true,
      required: true,
    },
  ],
  // 搜索字段
  searchFields: [
    { title: '姓名', field: 'nickname', searchType: 'input', searchWay: '=' },
    { title: '手机号', field: 'phone', searchType: 'input', searchWay: '=' },
  ],
  // 列表字段
  listFields: [
    { title: '#', field: '#', showUI: '_index' },
    { title: '姓名', field: 'nickname', showUI: '' },
    { title: '手机号', field: 'phone', showUI: '' },
    { title: '状态', field: 'status', showUI: 'status' },
    { title: '创建时间', field: 'createTime', showUI: 'dateTime' },
  ],
};
const regProductModel: ModelState = {
  name: 'regProduct',
  title: '注册有礼',
  type: 'list',
  tplName: 'list',
  // 列表操作
  listOperations: ['detail'],
  pageOperations: ['download'],
  // API 接口
  api: {
    list: '/admin/product/list',
    detail: '/admin/product/info',
    download: '/gotea/admin/product/list?export=1',
  },
  formFields: [    { title: '提交时间', field: 'createTime', showUI: 'dateTime' },
    { title: '公司名称', field: 'companyName', showUI: '' },
    { title: '联系人', field: 'name', showUI: '' },
    { title: '手机号', field: 'phone', showUI: '' },
    { title: '产品名称', field: 'productName', showUI: '' },
    { title: '铭牌号', field: 'nameplateId', showUI: '' },
    { title: '设备铭牌照片', field: 'cover', showUI: 'image' },
    { title: '公司地址', field: 'address', showUI: '' },
],
  searchFields: [
    {
      title: '提交时间',
      field: 'createTime',
      searchType: 'dateTimeRange',
      searchWay: '=',
    },
    {
      title: '关键词',
      field: 'query',
      searchType: 'input',
      searchWay: '=',
      placeholder: '公司名称或产品名称',
    }
   
  ],
  // 列表字段
  listFields: [
    { title: '#', field: '#', showUI: '_index', width: 50 },
    { title: '提交时间', field: 'createTime', showUI: 'dateTime' },
    { title: '公司名称', field: 'companyName', showUI: '' },
    { title: '联系人', field: 'name', showUI: '' },
    { title: '手机号', field: 'phone', showUI: '' },
    { title: '产品名称', field: 'productName', showUI: '' },
    { title: '铭牌号', field: 'nameplateId', showUI: '' },
    { title: '设备铭牌照片', field: 'cover', showUI: 'image' },
    { title: '公司地址', field: 'address', showUI: '' },
  ],
};
const experimentModel: ModelState = {
  name: 'experiment',
  title: '实验申请',
  type: 'list',
  tplName: 'list',
  // 列表操作
  listOperations: ['detail'],
  pageOperations: ['download'],
  // API 接口
  api: {
    list: '/admin/experiment/list',
    detail: '/admin/experiment/info',
    download: '/gotea/admin/experiment/list?export=1',
  },
  formFields: [{ title: '提交时间', field: 'createTime', showUI: 'dateTime',checked:true },
    { title: '公司名称', field: 'companyName', showUI: '' },
    { title: '申请人', field: 'name', showUI: '' },
    { title: '手机号', field: 'phone', showUI: '' },
    { title: '销售负责人手机号', field: 'sales', showUI: '' },
    { title: '期望实验时间', field: 'expectedTime', showUI: 'dateTime' },
    {
    field: 'type',
    title: '实验方式',
    formType: 'select',
    isForm: false,
    showUI: 'dict' ,
    required: true,
    options: [
      { label: '到访', value: '1' },
      { label: '邮寄', value: '2' },
    ],
  },
  { title: '样品描述及应用', field: 'sampleDescription', showUI: '' },
  { title: '样品主要成分', field: 'sampleMainComponent', showUI: '' },
  { title: '固定物(%)', field: 'sampleCircularity', showUI: '' },
  { title: '固含(%)', field: 'sampleSolventRatio', showUI: '' },
  { title: '粘度', field: 'sampleViscosity', showUI: '' },
  { title: '样品形态', field: 'sampleMorphology', showUI: '' },
  { title: '期望实验效果', field: 'expectedEffect', showUI: '' },
  { title: '需要的实验器材', field: 'requiredMachineProcess', showUI: '' },
  { title: '实验注意事项', field: 'experimentNotes', showUI: '' },
  { title: '样品是否需要检测', field: 'needDetection', showUI: 'dict' ,options: [
      { label: '是', value: '1' },
      { label: '否', value: '2' },
    ],},
  {
    field: 'status',
    title: '状态',
    formType: 'select',
    isForm: false,
    required: true,
    showUI: 'dict' ,
    options: [
      { label: '受理中', value: '1' },
      { label: '已完成', value: '2' },
    ],
  },{ title: '更新时间', field: 'updateTime', showUI: 'dateTime' },],
  searchFields: [
    {
      title: '提交时间',
      field: 'createTime',
      searchType: 'dateTimeRange',
      searchWay: '=',
    },
    { title: '申请人', field: 'query', searchType: 'input', searchWay: '=', placeholder: '申请人名称或手机号' },
    {
      title: '状态',
      field: 'status',
      searchType: 'select',
      searchWay: '=',
      options: [
        { label: '全部', value: '' },
        { label: '受理中', value: '1' },
        { label: '已完成', value: '2' },
      ],
    },
  ],
  // 列表字段
  listFields: [
    { title: '#', field: '#', showUI: '_index', width: 50 },
    { title: '提交时间', field: 'createTime', showUI: 'dateTime',checked:true },
    { title: '申请人', field: 'name', showUI: '' },
    { title: '手机号', field: 'phone', showUI: '' },
    { title: '销售负责人手机号', field: 'sales', showUI: '' },
    { title: '公司名称', field: 'companyName', showUI: '' },
    { title: '样品描述', field: 'sampleDescription', showUI: '' },
    { title: '实验方式', field: 'type', showUI: 'dict' },
    { title: '期望实验时间', field: 'expectedTime', showUI: 'dateTime' },
    { title: '状态', field: 'status', showUI: 'dict' },
    
    { title: '更新时间', field: 'updateTime', showUI: 'dateTime' },
  ],
};
const afterSaleModel: ModelState = {
  name: 'afterSale',
  title: '售后申请',
  type: 'list',
  tplName: 'list',
  // 列表操作
  listOperations: ['detail'],
  pageOperations: ['download'],
  // API 接口
  api: {
    list: '/admin/aftersale/list',
    detail: '/admin/aftersale/info',
    download: '/gotea/admin/aftersale/list?export=1',
  },
  formFields: [
    { title: '提交时间', field: 'createTime', showUI: 'dateTime' },
    { title: '公司名称', field: 'companyName', showUI: '' },
    { title: '申请人', field: 'name', showUI: '' },
    { title: '手机号', field: 'phone', showUI: '' },
    { title: '产品名称', field: 'productName', showUI: '' },
    { title: '铭牌号', field: 'nameplateId', showUI: '' },
    { title: '铭牌照片', field: 'cover', showUI: 'image' },
    { title: '需求描述', field: 'problemDesc', showUI: '' },
    { title: '期望处理时间', field: 'expectedProcessingTime', showUI: 'dateTime' },
    { title: '收货地址', field: 'address', showUI: '' },
    { title: '跟进人', field: 'handlerName', showUI: '' },
    {field: 'status',title: '状态',showUI: 'dict',options: [{ label: '待分配', value: '1' },{ label: '受理中', value: '2' },{ label: '已完成', value: '3' }]},
    { title: '设备问题描述', field: 'afterEquipmentDesc', showUI: '' },
    { title: '维修方案描述', field: 'afterMaintenanceScheme', showUI: '' },
    { title: '后续跟进计划', field: 'afterFollowUpPlan', showUI: '' },
    { title: '维修照片', field: 'afterMaintenancePhotos', showUI: 'imagesString' },
  ],
  searchFields: [
    {
      title: '提交时间',
      field: 'createTime',
      searchType: 'dateTimeRange',
      searchWay: '=',
    },
    
    { title: '关键词', field: 'query', searchType: 'input', searchWay: '=', placeholder: '公司名称或产品名称' },
    {
      title: '状态',
      field: 'status',
      searchType: 'dict',
      searchWay: '=',
    },
  ],
  // 列表字段
  listFields: [
    { title: '#', field: '#', showUI: '_index', width: 50 },
    { title: '提交时间', field: 'createTime', showUI: 'dateTime' },
    { title: '申请人', field: 'name', showUI: '' },
    { title: '手机号', field: 'phone', showUI: '' },
    { title: '产品名称', field: 'productName', showUI: '' },
    { title: '公司名称', field: 'companyName', showUI: '' },
    { title: '铭牌号', field: 'nameplateID', showUI: '' },
    { title: '铭牌照片', field: 'cover', showUI: 'image' },
    { title: '需求描述', field: 'problemDesc', showUI: '' },
    { title: '期望处理时间', field: 'ExpectedProcessingTime', showUI: 'dateTime' },
    // { title: '收货地址', field: 'address', showUI: '' },
    { title: '状态', field: 'status', showUI: 'dict' },
    { title: '跟进人', field: 'handlerName', showUI: '' },
  ],
};
const partsModel: ModelState = {
  name: 'parts',
  title: '配件申请',
  type: 'list',
  tplName: 'list',
  // 列表操作
  listOperations: ['detail'],
  pageOperations: ['download'],
  // API 接口
  api: {
    list: '/admin/parts/list',
    detail: '/admin/parts/info',
    download: '/gotea/admin/parts/list?export=1',
  },
  formFields: [
    { title: '创建时间', field: 'createTime', showUI: 'dateTime' },
    { title: '公司名称', field: 'companyName', showUI: '' },
    { title: '申请人', field: 'name', showUI: '' },
    { title: '手机号', field: 'phone', showUI: '' },
    { title: '产品名称', field: 'productName', showUI: '' },
    { title: '需求描述', field: 'desc', showUI: '' },
    { title: '收货地址', field: 'address', showUI: '' },
    { title: '铭牌号', field: 'nameplateId', showUI: '' },
    { title: '铭牌照片', field: 'cover', showUI: 'image' },
  ],
  searchFields: [
    {
      title: '提交时间',
      field: 'createTime',
      searchType: 'dateTimeRange',
      searchWay: '=',
    },
    { title: '关键词', field: 'query', searchType: 'input', searchWay: '=', placeholder: '公司名称或产品名称' },
    // {
    //   title: '状态',
    //   field: 'status',
    //   searchType: 'select',
    //   searchWay: '=',
    //   options: [
    //     { label: '全部', value: '' },
    //     { label: '受理中', value: '1' },
    //     { label: '已完成', value: '2' },
    //   ],
    // },
  ],
  // 列表字段
  listFields: [
    { title: '#', field: '#', showUI: '_index', width: 50 },
    // { title: '编号', field: 'id', showUI: '' },
    { title: '提交时间', field: 'createTime', showUI: 'dateTime' },
    { title: '公司名称', field: 'companyName', showUI: '' },
    { title: '申请人', field: 'name', showUI: '' },
    { title: '手机号', field: 'phone', showUI: '' },
    { title: '产品名称', field: 'productName', showUI: '' },
    { title: '需求描述', field: 'desc', showUI: '' },
    { title: '铭牌号', field: 'nameplateId', showUI: '' },
    { title: '铭牌照片', field: 'cover', showUI: 'image' },
    { title: '收货地址', field: 'address', showUI: '' },
  ],
};

const equipmentModel: ModelState = {
  name: 'equipment',
  title: '新设备安装管理',
  type: 'list',
  tplName: 'list',
  // 列表操作
  listOperations: ['edit','detail'],
  pageOperations: ['create','download', 'import'],
  options:{
    importTemplateUrl: 'https://atshphsc.oss-cn-beijing.aliyuncs.com/web/模版1.csv',
  },
  // API 接口
  api: {
    list: '/admin/equipment/list',
    detail: '/admin/equipment/info',
    download: '/gotea/admin/equipment/list?export=1',
    import: '/gotea/admin/equipment/import',
    update: '/admin/equipment/save',
  },
  formFields: [
    { title: '创建时间', field: 'createTime',isForm: false, formType: 'dateTime', showUI: 'dateTime' ,extOptions:{showTime: true,format: 'YYYY-MM-DD HH:mm:ss',valueFormat: 'timestamp'}},
    { title: '安装时间', field: 'installationTime',isForm: true,formType: 'dateTime', showUI: 'dateTime' ,extOptions:{showTime: true,format: 'YYYY-MM-DD HH:mm:ss',valueFormat: 'timestamp'}},
    { title: '公司名称', field: 'companyName', isForm: true,required: true, formType: 'input', showUI: '' },
    { title: '设备型号', field: 'productName', isForm: true,required: true, formType: 'input', showUI: '' },
    { title: '产品应用', field: 'productApplication', isForm: true, formType: 'input', showUI: '' },
    { title: '铭牌号', field: 'nameplateId', isForm: true,required: true, formType: 'input', showUI: '' },
    { title: '铭牌照片', field: 'cover',isForm: true,formType: 'image', showUI: 'image' },
    { title: '联系人', field: 'name', isForm: true,formType: 'input', showUI: '' },
    { title: '手机号', field: 'phone',isForm: true,formType: 'input', showUI: '' },
    { title: '地址', field: 'address',isForm: true,formType: 'textarea', showUI: '' },
    { title: '售后人员', field: 'afterSalesId', isForm: true,formType: 'selectApi',  showUI: 'hide' ,extOptions:{api: '/user/stafflist?role=after_sales',labelField: 'nickname',valueField: 'uid'}},
    { title: '售后人员', field: 'afterSalesName', isForm: false,  showUI: '' , },
    {field: 'status',title: '状态',showUI: 'dict',options: [  
      { label: '受理中', value: '1' },
      { label: '已完成', value: '2' },
    ]},
    { title: '安装方案描述', field: 'installationPlan', showUI: '' },
    { title: '后续跟进计划', field: 'followUpPlan', showUI: '' },
   { title: '安装照片', field: 'maintenanceCovers', showUI: 'imagesString' },
  ],
  searchFields: [
    {
      title: '提交时间',
      field: 'createTime',
      searchType: 'dateTimeRange',
      searchWay: '=',
    },
    { title: '关键词', field: 'query', searchType: 'input', searchWay: '=', placeholder: '公司名称或产品名称' },
    {
      title: '状态',
      field: 'status',
      searchType: 'select',
      searchWay: '=',
      options: [
        { label: '全部', value: '' },
        { label: '受理中', value: '1' },
        { label: '已完成', value: '2' },
      ],
    },
  ],
  // 列表字段
  listFields: [
    { title: '#', field: '#', showUI: '_index', width: 50 },
    { title: '创建时间', field: 'createTime', showUI: 'dateTime' },
    { title: '公司名称', field: 'companyName', showUI: '' },
    { title: '设备型号', field: 'productName', showUI: '' },
    { title: '产品应用', field: 'productApplication', showUI: '' },
    { title: '铭牌号', field: 'nameplateId', showUI: '' },

    { title: '联系人', field: 'name', showUI: '' },
    { title: '手机号', field: 'phone', showUI: '' },
  
    { title: '收货地址', field: 'address', showUI: '' },
    { title: '铭牌照片', field: 'cover', showUI: 'image' },
    { title: '售后人员', field: 'afterSalesName', showUI: '' },
  ],
};

const getDefineModelByName = (name: string): ModelState | undefined => {
  if (name === 'account') {
    return accountModel;
  }
  if (name === 'productCate') {
    return productCateModel;
  }
  if (name === 'product') {
    return productModel;
  }
  if (name === 'video') {
    return videoModel;
  }
  if (name === 'appInfo') {
    return appInfoModel;
  }

  if (name === 'user') {
    return userModel;
  }
  if (name === 'banner') {
    return bannerModel;
  }

  if (name === 'reg') {
    return regProductModel;
  }
  if (name === 'experiment') {
    return experimentModel;
  }
  if (name === 'aftersale') {
    return  afterSaleModel
  }
  if (name === 'parts') {
    return partsModel;
  }
  if (name === 'equipment') {
    return equipmentModel;
  }

  return undefined;
};

export { getDefineModelByName };
